import React from 'react';

function ProgressBar({ progress }) {
    const progressStyle = {
        width: `${progress}%`,
    };

    return (
        <div className="w-full bg-gray-200 rounded-full h-1.5 mb-4 dark:bg-gray-700">
            <div className="bg-progressBarBlue h-1.5 rounded-full" style={progressStyle} />
        </div>
    );
}

export default ProgressBar;
